var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay-container"},[_c('div',{staticClass:"product-info"},[_c('h3',[_vm._v("Knowit Credits Charge: "+_vm._s(_vm.charge_description))]),_c('h1',[_vm._v("US$"+_vm._s(_vm.amount))])]),_c('div',{attrs:{"id":"checkout"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }